// extracted by mini-css-extract-plugin
module.exports = {"containerQRCode":"TankQRCode_containerQRCode__3Wcdo","qrcode":"TankQRCode_qrcode___TS7U","name":"TankQRCode_name__3IbL5"};